/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {View} from '@instructure/ui-view'
import {CloseButton} from '@instructure/ui-buttons'
import CommonFileInfo from './CommonFileInfo'
import type {File} from '../../../../interfaces/File'

export interface FilePreviewTrayProps {
  onDismiss: () => void
  item: File
}

export const FilePreviewTray = ({onDismiss, item}: FilePreviewTrayProps) => {
  return (
    <View
      as="div"
      background="primary-inverse"
      padding="medium"
      style={{minHeight: '100%'}}
      themeOverride={{
        backgroundPrimaryInverse: '#0F1316',
      }}
    >
      <CloseButton
        placement="end"
        offset="small"
        screenReaderLabel="Close"
        onClick={onDismiss}
        color="primary-inverse"
        data-testid="tray-close-button"
      />
      <CommonFileInfo item={item} />
    </View>
  )
}
